<template>
    <div class="uk-padding">
        <div class="">
            <h2 class="uk-heading-bullet" style="margin-top: -30px">See what our students say?</h2>
            <div class="uk-child-width-1-3@m" uk-grid>
                <div>
                    <div class="uk-card uk-card-default">
                        <div class="uk-card-media-top">
                            <img src="/butterfly.jpg" alt="">
                        </div>
                        <div class="uk-card-body" style="padding: 10px !important;">
                            <h3 class="uk-card-title">Michelle Wright</h3>
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.</p>
                        </div>
                    </div>
                </div>
                <div>
                    <div class="uk-card uk-card-default">
                        <div class="uk-card-media-top">
                            <img src="/butterfly.jpg" alt="">
                        </div>
                        <div class="uk-card-body" style="padding: 10px !important;">
                            <h3 class="uk-card-title">Tupac Shakur</h3>
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.</p>
                        </div>
                    </div>
                </div>
                <div>
                    <div class="uk-card uk-card-default">
                        <div class="uk-card-media-top">
                            <img src="/butterfly.jpg" alt="">
                        </div>
                        <div class="uk-card-body" style="padding: 10px !important;">
                            <h3 class="uk-card-title">Chantelle Empire</h3>
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.</p>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "studentOpinions"
    }
</script>

<style scoped>

</style>